const url = "/api/v1/participations";

export interface ParticipationsCreateParams {
  responseId: string;
}

export const participationsCreateQuery = (
  params: ParticipationsCreateParams,
) => ({
  url,
  method: "POST",
  body: { participation: params },
});
